import { z } from "zod/v4";
import { courtIdSchema } from "./ids";
import { currencySchema } from "./venue";

const count = z.number().int().nonnegative();

/** What a range of venue-local days added up to (owners and managers). */
export const venueReportSchema = z.object({
	courts: z.array(
		z.object({
			bookedMinutes: count,
			bookings: count,
			courtId: courtIdSchema,
			name: z.string(),
			openMinutes: count,
			paidCents: count,
		}),
	),
	currency: currencySchema,
	from: z.iso.date(),
	to: z.iso.date(),
	totals: z.object({
		bookedMinutes: count,
		bookings: count,
		cancelled: count,
		deskBookings: count,
		noShows: count,
		onlineBookings: count,
		openMinutes: count,
		/** Unpaid desk bookings that already started: what staff should chase. */
		owedCents: count,
		/** Collected: captures, desk-recorded payments, played pay-at-the-venue bookings. */
		paidCents: count,
		/** Player pay-at-the-venue bookings still ahead: expected, not collected. */
		expectedCents: count,
	}),
});

export type VenueReport = z.infer<typeof venueReportSchema>;
